// @flow
import type { ID } from "data/enums/types"
import type { Mutation } from "common/graphql/types"
import type { DateString } from "data/units/date/types"
import gql from "graphql-tag"
import { reservationFragment } from "./fragments"
import type { Reservation, AccessoryQueryInput } from "../types"
import { reservationListQuery, reservationCountQuery } from "./queries"

export const createReservationMutation: Mutation<
  {
    input: {
      productVariantId: ID,
      affiliateId: ID,
      profileId: ID,
      start: DateString,
      end: DateString,
      paymentMethod: "card",
      accessories: AccessoryQueryInput[],
      shippingAddress: ?string,
    },
  },
  Reservation,
> = {
  gql: gql`
    mutation createReservationMutation($input: ReservationInput!) {
      reservation {
        create(input: $input) {
          ...reservationFragment
        }
      }
    }
    ${reservationFragment}
  `,
  selector: ["reservation", "create"],
  refetch: [reservationListQuery, reservationCountQuery],
}

export const cancelReservationMutation: Mutation<{| reservationId: ID |}> = {
  gql: gql`
    mutation cancelReservationMutation($reservationId: Int!) {
      reservation {
        cancel(reservationId: $reservationId)
      }
    }
  `,
  refetch: [reservationListQuery, reservationCountQuery],
}

export const extendReservationMutation: Mutation<
  { reservationId: ID, end: DateString },
  Reservation,
> = {
  gql: gql`
    mutation extendReservationMutation($reservationId: Int!, $end: String!) {
      reservation {
        extendDuration(reservationId: $reservationId, end: $end) {
          ...reservationFragment
        }
      }
    }
    ${reservationFragment}
  `,
  selector: ["reservation", "extendDuration"],
  refetch: [reservationListQuery, reservationCountQuery],
}

export const buyItMutation: Mutation<{| reservationId: ID |}> = {
  gql: gql`
    mutation buyItMutation($reservationId: Int!) {
      reservation {
        buyIt(reservationId: $reservationId)
      }
    }
  `,
  refetch: [reservationListQuery, reservationCountQuery],
}



// WEBPACK FOOTER //
// ./src/data/reservations/graphql/mutations.js